export const ROUTES = {
  AGGREGATOR_BALANCE: "/portal/balance/",
  TRANSACTION_SOLDE: "/portal/transactions/",
  RECENT_TRANSACTIONS: "/portal/analytics/recent/",
  ANALYTICS_SUMMARY: "/portal/analytics/summary/",
  ANALYTICS_OPERATORS: "/portal/analytics/operators/",
  WEBHOOK_REGISTER: "/webhook/register/",
  WEBHOOK_EVENTS: "/webhook/events/",
  WEBHOOK_LIST: "/webhook/",
  SELF_RECHARGE_LIST: "/portal/self-recharge/",
  SELF_RECHARGE_SUBMIT: "/portal/self-recharge/submit/",
  LOGIN: "/auth/token/",
  REFRESH: "/auth/refresh/",
  PROFILE: "/portal/profile/",
  API_KEYS: "/portal/keys/",
  API_KEYS_GENERATE: "/portal/keys/generate/",
  API_KEYS_REVOKE: (keyId: string) => `/portal/keys/${keyId}/revoke/`,
  API_KEYS_RENAME: (keyId: string) => `/portal/keys/${keyId}/rename/`,
  KEYS_ROTATE_BOOTSTRAP: "/portal/keys/rotate-bootstrap/",
  TRANSACTIONS: "/payment/transactions/",
  FEES_SIMULATE: "/portal/fees/simulate/",
  PAYMENT_OPERATORS: "/portal/operators/",
  PRODUCTION_ACCESS_REQUEST: "/portal/request-production/",
};

export const IMAGES = {
  MTN_LOGO: "/Mtn_momo.png",
  ORANGE_LOGO: "/Orange_money.png",
};
